<!-- 思维陷阱 填写 卡片组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="card" v-if="currentCard">
        <div class="tag">{{ currentCard.tag }}</div>
        <div class="chat-textarea">
          <div class="question">
            {{ currentCard.question }}
          </div>
          <div class="examples">
            {{ currentCard.examples }}
          </div>
          <div class="chat-text">
            我曾经陷入过这种思维陷阱吗？
          </div>
          <div class="all-btn">
            <div
              :class="currentCard.selectYesNo === 'yes' ? 'item-btn active' : 'item-btn'"
              @click="submitFn('yes')"
            >
              是的
            </div>
            <div
              :class="currentCard.selectYesNo === 'no' ? 'item-btn active' : 'item-btn'"
              @click="submitFn('no')"
            >
              不是
            </div>
          </div>
          <div v-if="currentCard.selectYesNo === 'yes'" class="textarea-wrapper">
            <textarea :disabled="!isCanEdit" v-model="currentCard.value" placeholder="我的想法是......" />
          </div>
          <button v-if="currentCard.selectYesNo === 'yes' && isCanEdit" class="confirm-btn" @click="confirmFn">
            确定
          </button>
        </div>
      </div>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>

export default {
  name: 'ChatText',
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          isShowTime: true
        };
      }
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  components: {},
  data() {
    return {
      ideaValue: '',
      selectYesNo: '',
      cardList: [
        {
          tag: '非黑即白',
          placeholder: '点击输入我的例子',
          question: '又叫极端化思维、两极化思维或全或无思维，指的是我们用非此即彼或极端的方式看待即只看到某一情形的两个极端情况，没有看到其中间状态。其实无论看待情形、事件还是人，往往需要从连续谱、动态或多维度的方面去看待。',
          examples: '举例：我是个失败者；我坏；他不是好人；他是个混蛋。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '贴标签',
          placeholder: '点击输入我的例子',
          question: '给自己或他人贴上一个夸大的负面标签，而不考虑那些更合理的正面或中立方面。即用充满负性情绪、激发自己负性感受的词语描述自己或他人。',
          examples: '举例：如果我没有做好这件事，我就是一个失败者；这个情况太糟糕了；我不正常；其他人不可信。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '灾难化思维',
          placeholder: '点击输入我的例子',
          question: '又叫预测未来，指的是负性地或消极地预测未来，而不考虑其他更有可能发生的或好的结局。把事情的后果灾难化，认为将来肯定发生糟糕的事情而且自己也承受不了。',
          examples: '举例：我肯定做不好；我的未来会一塌糊涂；我注定会失败；我考不上大学，将来会像乞丐一样。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '感情用事',
          placeholder: '点击输入我的例子',
          question: '又叫情绪推理，完全相信个人的感觉或直觉是对的合理的或者就是事实。也就是，完全接纳个人强烈情绪下的感觉，据此认为它就是对的或事实，却忽略或低估了相反的证据。即个体感觉到什么就认定会发生什么，或者认为自己的感觉就是事实或对的。',
          examples: '举例：我知道我各方面的条件还可以，但我就感觉自己是个失败者。我觉得别人不喜欢我。我觉得别人讨厌我。我预感到我做不好。我感觉到我会被骗，我肯定会被骗。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '低估或贬低正性信息',
          placeholder: '点击输入我的例子',
          question: '认为个人那些积极的经历、事件行为或品质都不重要。即贬低否定或忽略个人好的、正面的积极的经历、事件、行为或品质。',
          examples: '举例：我这件事做好了，并不说明我能力强，只是运气好而已。我考上了大学，没什么了不起，现在是个人就能上大学。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '夸大或缩小',
          placeholder: '点击输入我的例子',
          question: '评价自己、他人、事件或情形时不合理地高估消极面、负面，或者低估正面、积极面。即放大负面、消极面的重要性，缩小正面、积极面的重要性。',
          examples: '举例：这个成绩就说明我有多无能。这门课得高分并不说明我有能力，真正有能力的人任何一门课都是全年级第一。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '选择性提取',
          placeholder: '点击输入我的例子',
          question: '又叫心理过滤，指的是过分关注负面细节，而把其余的内容忽视了，没有用全局的视角去看待。即只关注一个情形中的负面或不好的方面，而忽略了中性和正性的方面。',
          examples: '举例：评分中有一条得分低，这就说明我不行。他不够敏锐，不是一个合格的老师。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '以偏概全',
          placeholder: '点击输入我的例子',
          question: '又叫过度概括，指的是根据目前的某种不利，做出一个过度的负性概括。即把当前的某种不利看作常态，或在缺乏有力证据的情况下过早得出负性结论。',
          examples: '举例：参会人员中有人对会务不满，那就说明我做得很糟糕。这件事都做成这样，还有什么事能做好?',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '读心症',
          placeholder: '点击输入我的例子',
          question: '凭别人的表情、语气、语调或态度，就认为自己知道别人内心的想法，而不去考虑其他更合理的可能性。',
          examples: '举例：他在心里笑话我。他认为我丑。他在讽刺我。他看不起我。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '个人化或揽责上身',
          placeholder: '点击输入我的例子',
          question: '认为别人的行为或外部事件源于自己或与自己有关，而不考虑其他更合理的解释。即让自己承担不应该承担的责任。',
          examples: '举例：他想指责我，那还是我有问题，他为什么不指责别人？那个人敢对我很无理，就是因为我招人厌。他这样对待我，都是因为我不好。',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '应该和必须声明',
          placeholder: '点击输入我的例子',
          question: '认为自己或他人就应该或者不应该做什么，当此期望或要求不能被满足时，则高估坏的结局。这与黑白思维、贴标签、夸大或缩小的认知歪曲有关。',
          examples: '举例：我犯了一个大错(我不应该犯这个错)。他应该知恩图报。他不应该那样对待我！他凭什么这么跟我说话?',
          selectYesNo: '',
          value: ''
        },
        {
          tag: '管状视野',
          placeholder: '点击输入我的例子',
          question: '视野局限，只看到负面或不好的部分。这跟心理过滤、夸大或缩小相似。',
          examples: '举例：我一无是处，个子矮，长得丑，工作不行。',
          selectYesNo: '',
          value: ''
        },
      ],
      currentCard: null
    };
  },
  created() {
  },
  mounted() {
    if(this.nextData?.step_data?.survey?.qstList[0].answer) {
      let useData = this.nextData?.step_data?.survey?.qstList[0].answer;
      this.currentCard = useData;
    } else {
      this.currentCard = this.cardList[this.cardData.step_data.index - 1]
    }
  },
  methods: {
    // 提交数据
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type + this.cardData.step_data.index,
                answer: this.currentCard,
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
    submitFn(val) {
      if(!this.isCanEdit) {
        return;
      }
      this.currentCard.selectYesNo = val;
      if(val === 'no') {
        this.confirmFn()
      }
    }
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  .card {
    width: 100%;
    background: rgba(232, 227, 252, 1);
    padding: 15px;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 10px;
    .tag {
      min-width: 93px;
      line-height: 22px;
      border-radius: 0px 15px 15px 0px;
      background: #C0ABF6;
      margin-left: -15px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 4px;
      padding: 0 10px;
      box-sizing: border-box;
      display: inline-block;
    }
  }
  
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    padding: 0 12px;
    line-height: 23px;
  }
  .all-btn {
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin-top: 8px;
    margin-bottom: 16px;
    .item-btn {
      height: 27px;
      border-radius: 70px;
      background: #ffffff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0px;
      color: $text-color;
      margin-right: 10px;
    }
    .active {
      background: rgba(192, 171, 246, 1);
      color: #fff;
    }
  }
  .chat-textarea{
    width: 100%;
  }
  .question {
    box-sizing: border-box;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 23px;
    color: rgba(59, 59, 59, 1);
    margin-bottom: 10px;
  }
  .examples {
    box-sizing: border-box;
    font-size: 12px;
    padding: 0 12px;
    font-weight: 400;
    line-height: 17.38px;
    color: rgba(121, 72, 234, 0.4);
    margin-bottom: 10px;
  }
  .textarea-wrapper {
    width: 100%;
    border-radius: 17px;
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
    textarea {
      width: 100%;
      box-sizing: border-box;
      padding: 16px;
      height: 69px;
      font-size: 10px;
      font-weight: 300;
      line-height: 14.48px;
      text-align: left;
      border: none;
    }
  }
}
.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12px;
  background: #AD7EFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: #fff;
  border: none;
  margin: 10px auto 0;
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
